import { Observable } from 'rxjs';

export enum FilterInputType {
  SearchBar = 'searchbar',
  Select = 'select',
  Separator = 'separator',
  ShowMoreToggle = 'show-more-toggle',
  Date = 'date',
  MultiSelect = 'multi-select',
  PeriodRange = 'periodRange',
  AutoCompleteBar = 'autocompletebar',
  ClearValues = 'clearvalues',
  Range = 'range',
  Button = 'button',
  EqualNoCase = 'equalnocase',
}

export type DefaultSelectionValue = string | number;

export interface FormGroupValue<T = DefaultSelectionValue> {
  [fcField: string]: T;
}

export interface InputProps<T = DefaultSelectionValue> {
  type: FilterInputType;
  position?: number;
  field?: string;
  placeholder?: string;
  values?: any[];
  dataType?: string;
  inputType?: string;
  disabled?: boolean;
  tooltip?: string;
  /**
   * When specified, the 'all behavior' will apply for this item
   */
  allKey?: string | number;
  value?: T | T[];
  css?: string;
  label?: string;
  options?: InputPropOption[];
  lookupCategory?: string;
  /**
   * This is used in the simple select component. This flag adds the given option at the beginning of the options.
   * This flag only works with lookupCategory
   */
  addNoneOption?: { [key: string]: any };
  dataKey?: string;
  translateOptionsRequired?: boolean;
  /**
   * Only works when the options are configured (Won't work with lookupCategory)
   * and don't work well if the allKey is used
   */
  hasFilter?: boolean;
  controlOptions?: any;
  width?: string;
  hint?: HintProps;
  // An identifier to distinguish whenever this property changes in the filters
  inputIdentifier?: string;
  // Flag for check the label as titlecase or not.
  isTitleCaseRequired?: boolean;
  optionsEndpoint?: Observable<any>;
  // Flag for check the label needs translation or not.
  isLabelTranslated?: boolean;
  // Added to be used in the Button type element
  id?: string;

  //pass payload and avoid select option in dropdown
  lookupPayload?: boolean;
}

export interface InputPropOption {
  key: any;
  value: string;
  actualValue?: any;
  name?: any;
}

export interface HintProps {
  svgIcon: string;
  textMessage?: string;
  htmlMessage?: string;
}

export interface FilterableComponent<T = DefaultSelectionValue> {
  filterChange(selectedFilters: FormGroupValue<T>): void;
}
